import React, { useState } from 'react';
import Icon from '../../../Assets/Icon/CustomIcon';

export default function InputText({
  name,
  schema,
  value,
  onChange,
  maxLength,
  type = 'text',
  disabled = false,
  inputMode,
}) {
  const [isFocused, setIsFocused] = useState(false);
  const [lengthError, setLengthError] = useState('');

  const fieldMeta = schema?.fields?.[name] || {};
  const label = fieldMeta.label || name;
  const placeholder = fieldMeta.placeholder || `${label}을(를) 입력하세요.`;
  const required = fieldMeta.required === 'Y';

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.target.blur();
    }
  };

  const handleChange = (e) => {
    const newValue = e.target.value;

    if (maxLength && newValue.length > maxLength) {
      setLengthError(`최대 ${maxLength}자까지 입력 가능합니다.`);
    } else {
      setLengthError('');
    }

    onChange(e);
  };

  const hasValue = value.trim() !== '';
  const showCheck = hasValue && !lengthError;

  return (
    <div
      style={{ display: 'flex', flexDirection: 'column', marginBottom: '8px' }}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <label
          style={{
            fontWeight: 'bold',
            fontSize: '16px',
            color: '#2c2c2cff',
            marginBottom: '4px',
          }}
        >
          {label}
          {required && <span style={{ color: '#E65959' }}> *</span>}
        </label>
        <span
          style={{
            marginLeft: '8px',
            fontSize: '16px',
            color: lengthError ? '#E65959' : '#4C48BE',
          }}
        >
          {lengthError ? <Icon.Caution /> : showCheck && <Icon.Check />}
        </span>
      </div>

      <div style={{ position: 'relative', width: '100%' }}>
        <textarea
          type={type}
          value={value}
          onChange={handleChange}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          required={required}
          disabled={disabled}
          maxLength={maxLength}
          inputMode={inputMode}
          style={{
            width: '100%',
            padding: '8px',
            borderRadius: '8px',
            border: '1px solid #C4C4C4',
            borderColor: lengthError
              ? '#E65959'
              : isFocused
                ? '#4C48BE'
                : '#C4C4C4',
            fontSize: '16px',
            fontWeight: 'bold',
            transition: 'border-bottom-color 0.2s',
            outline: 'none',
            resize: 'none',
            minHeight: name === 'comment' && '100px',
            ...(disabled && {
              backgroundColor: '#f0f0f0',
              cursor: 'not-allowed',
            }),
          }}
        />

        {maxLength && (
          <span
            style={{
              position: 'absolute',
              bottom: '8px',
              right: '8px',
              fontSize: '12px',
              color: value.length >= maxLength ? '#E65959' : '#999',
            }}
          >
            {value.length}/{maxLength}
          </span>
        )}
      </div>

      {lengthError && (
        <span
          style={{
            color: '#E65959',
            fontSize: '14px',
            marginLeft: '4px',
          }}
        >
          {lengthError}
        </span>
      )}
    </div>
  );
}
